<template>
  <div class="app">
    <AppHeader/>
    <div class="app-body" :class="{ 'no-margin': $route.query.app }">
      <Sidebar/>
      <main class="main">
        <!--<breadcrumb :list="list"/>-->
        <div class="container-fluid container-nobreadcrumb">
          <router-view></router-view>
        </div>
      </main>
      <AppAside/>
    </div>
    <AppFooter/>
  </div>
</template>

<script>
import AppHeader from '@/components/containerComponents/Header'
import Sidebar from '@/components/containerComponents/Sidebar'
import AppAside from '@/components/containerComponents/Aside'
import AppFooter from '@/components/containerComponents/Footer'
import Breadcrumb from '@/components/containerComponents/Breadcrumb'

export default {
  name: 'full',
  components: {
    AppHeader,
    Sidebar,
    AppAside,
    AppFooter,
    Breadcrumb
  },
  computed: {
    name () {
      return this.$route.name
    },

    list () {
      return this.$route.matched
    }
  }
}
</script>

<style lang="less">
.container-fluid.container-nobreadcrumb{
  padding-top: 20px;
}
.no-margin{
  margin: 0px !important;
}
</style>



// WEBPACK FOOTER //
// Full.vue?7b3ecbbf